// modifer: styles/jss/nextjs-material-kit-pro/pages/sectionsSections/blogsStyle
import {
  section,
  container,
  title,
  cardTitle,
  coloredShadow,
  description
} from 'styles/jss/original/base';

const styles = {
  section,
  container,
  title: {
    ...title,
    textAlign: 'center'
  },
  coloredShadow,
  cardTitle,
  description: {
    ...description,
    fontSize: '0.9375rem'
  },
  cardCategory: {
    marginBottom: '0',
    marginTop: '10px',
    fontWeight: 'bold',
    '& svg,& .fab,& .fas,& .far,& .fal,& .material-icons': {
      position: 'relative',
      top: '8px',
      lineHeight: '0'
    }
  },
  card: {
    marginBottom: '80px',
    '@media (max-width: 576px)': {
      marginTop: '30px',
      marginBottom: '0'
    }
  },
  orderEven: {
    order: '2',
    '@media (max-width: 576px)': {
      order: 'initial'
    }
  }
};

export default styles;
